<app-dialog [config]="config" (actionButtonClicked)="onActionButtonClicked()">
    <ng-container dialog-title>
        {{ data.caption }}
    </ng-container>
    <ng-container dialog-process-in-progress>
        <div class="batch-progress mb-2" *ngIf="state.inProgress" role="progressbar" aria-busy="true">
            <div class="batch-progress__fill"></div>
        </div>

        <div class="d-flex align-items-center mb-3"
             [class.text-danger]="!state.inProgress && !state.succeeded">
            <span>{{ state.summaryText }}</span>
        </div>

        <div class="table-responsive batch-result-table" *ngIf="state.rows.length > 0">
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Account number</th>
                        <th>Outcome</th>
                        <th>Details</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of state.rows">
                        <td>{{ row.sequence }}</td>
                        <td>{{ row.accountReferenceId || '-' }}</td>
                        <td [ngClass]="getOutcomeClass(row.outcome)">{{ getOutcomeName(row.outcome) }}</td>
                        <td>{{ row.reason || '' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="d-flex justify-content-start mt-2" *ngIf="createdAccountNumbers.length > 0">
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="copyAccountNumbers()">
                {{ copied ? 'Copied!' : 'Copy account numbers' }}
            </button>
        </div>
    </ng-container>
</app-dialog>
